import { NATIVE_ADDRESS } from "@/constants/addresses";
import { getAddress, isAddress, zeroAddress } from "viem";

export const shortenAddress = (
  address: string = zeroAddress,
  prefixChars = 4,
  suffixChars = 4
) => {
  if (isAddress(address) && address !== zeroAddress) {
    const parsed = getAddress(address);
    return `${parsed.substring(0, prefixChars + 2)}...${parsed.substring(
      42 - suffixChars
    )}`;
  }
  return null;
};

export const isNativeAddress = (address?: string) => {
  return address?.toLowerCase() === NATIVE_ADDRESS.toLowerCase();
};
